const $ = jQuery.noConflict();

class StickyHeader {
    constructor(mainHeader='.main-header') {
        this.mainHeader = mainHeader;
    }
    init() {
       if($(window).scrollTop() > 0) {
           $(this.mainHeader).addClass('main-header--sticky');        
       }
       else {
           if($(this.mainHeader).hasClass('main-header--sticky')) {
            $(this.mainHeader).removeClass('main-header--sticky');
           }
       }
    }
   
}

export default StickyHeader;
